import { ILoginData, ILoginSettings, IUserCredentials } from '@fi-shared/fi-auth-shared/fi-auth-shared';
import { FiLoginType } from '@fi-shared/fi-auth-shared/fi-login-type';

export class DesktopUserCredentialModel implements IUserCredentials {
    Login: string;
    Password: string;
    ShouldStayLoggedIn: boolean;

    constructor(login?: string, password?: string, shouldStayLoggedIn?: boolean) {
        this.Login = login;
        this.Password = password;
        this.ShouldStayLoggedIn = shouldStayLoggedIn;
    }

    toLoginData(loginSettings: ILoginSettings): ILoginData {
        return {
            userCredentials: this,
            loginSettings: loginSettings,
            loginType: FiLoginType.DesktopLoginPassword,
        };
    }
}
